import { media, styled } from '@styles';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: -10px;
  ${media.xLargeScreen`
    margin-top: -9px;
  `}
  ${media.largeScreen`
    margin-top: -6px;
  `}
  ${media.mediumScreen`
    margin-top: 0;
  `}
  ${media.smallScreen`
    justify-content: center;
  `}
`;
export const Button = styled.button`
  padding: 5px 33px;
  background: ${({ theme: { colors } }) => colors.light};
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  ${media.smMediumScreen`
    width: 100%;
  `}
`;

export const Text = styled.span`
  font-family: ${(props) => props.theme.typography.labelFontSize};
  line-height: 100%;
  color: ${({ theme: { colors } }) => colors.baseFont};
  opacity: 0.5;
`;

export const Icon = styled.img`
  margin-left: 5px;
  width: 12px;
  height: 12px;
  ${media.largeScreen`
    width: 10px;
    height: 10px;
  `}
  ${media.mediumScreen`
    width: 14px;
    height: 14px;
  `}
`;
